const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ReignOfTerror extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.ReignOfTerror,
            "The weakest civilization loses 1 population.",
            {}
        )
    }
}

module.exports = ReignOfTerror;